import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

const DailyChallenge = () => {
  const [challenge, setChallenge] = useState<any>(null);

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    supabase
      .from("daily_challenges")
      .select("*")
      .eq("is_active", true)
      .lte("challenge_date", today)
      .order("challenge_date", { ascending: false })
      .limit(1)
      .maybeSingle()
      .then(({ data }) => setChallenge(data));
  }, []);

  if (!challenge) return null;

  const Inner = (
    <div className="bg-gradient-to-br from-pink-100 via-amber-50 to-cyan-100 border-2 border-pink-200 rounded-3xl p-4 md:p-5 shadow flex items-center gap-4">
      <div className="text-4xl">{challenge.emoji || "⚡"}</div>
      <div className="flex-1">
        <div className="flex items-center gap-2 text-pink-700 text-xs font-bold uppercase">
          <Sparkles className="w-4 h-4" /> Daily Challenge
        </div>
        <h3 className="text-lg font-extrabold text-gray-900">{challenge.title}</h3>
        {challenge.description && (
          <p className="text-sm text-gray-700">{challenge.description}</p>
        )}
      </div>
      <div className="bg-amber-400 text-white font-bold px-4 py-2 rounded-full shadow">
        Start
      </div>
    </div>
  );

  return (
    <section className="container mx-auto px-4 py-3">
      {challenge.link_url ? (
        <Link to={challenge.link_url}>{Inner}</Link>
      ) : (
        Inner
      )}
    </section>
  );
};

export default DailyChallenge;
